import { useEffect, useRef } from "react";
import { Megaphone } from "lucide-react";

const CLIENT = process.env.REACT_APP_ADSENSE_CLIENT;
const SLOT = process.env.REACT_APP_ADSENSE_SLOT;

function loadScript() {
  if (!CLIENT || typeof window === "undefined") return;
  if (document.querySelector("script[data-adsense]")) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${CLIENT}`;
  s.crossOrigin = "anonymous";
  s.setAttribute("data-adsense", "1");
  document.head.appendChild(s);
}

// A single AdSense unit. Shows a subtle placeholder frame so an unfilled slot
// (e.g. before site approval / in preview) still looks intentional.
export function GoogleAd({ format = "auto", minHeight = 100, className = "", label }) {
  const pushed = useRef(false);
  useEffect(() => {
    if (!CLIENT || !SLOT) return;
    loadScript();
    if (pushed.current) return;
    pushed.current = true;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.warn("AdSense push failed:", e?.message || e);
    }
  }, []);

  return (
    <div
      className={`relative rounded-xl bg-[#12121A] border-2 border-dashed border-white/10 overflow-hidden ${className}`}
      style={{ minHeight }}
      data-testid="google-ad"
    >
      {label && (
        <span className="absolute top-1 right-2 z-0 text-[9px] font-mono2 tracking-widest text-[#505060] uppercase">
          {label}
        </span>
      )}
      <div className="absolute inset-0 z-0 flex flex-col items-center justify-center text-[#3a3a45] pointer-events-none">
        <Megaphone size={20} />
        <span className="text-[10px] font-mono2 tracking-widest uppercase mt-1">Ad</span>
      </div>
      {CLIENT && SLOT && (
        <ins
          className="adsbygoogle relative z-10"
          style={{ display: "block", minHeight }}
          data-ad-client={CLIENT}
          data-ad-slot={SLOT}
          data-ad-format={format}
          data-full-width-responsive="true"
        />
      )}
    </div>
  );
}

export const adsConfigured = Boolean(CLIENT && SLOT);
